import styled from 'styled-components';
import { color, font, query, space } from '@design/templateFns';

import Block from '@components/Layout/Block';
import { VerticalLineSeparator } from '@components/MiscComponents/VerticalLineSeparator';

//
//
// StackedMaster styles
//
export const StyledBlock = styled(Block)`
  > div {
    display: flex;
    flex-direction: column;
  }
`;

export const SecondaryContentWrapper = styled.div`
  display: flex;
  flex-direction: column;

  @media screen and (${query.atLeast('desktop')}) {
    flex-direction: row;
    flex-wrap: wrap;

    > div:nth-child(even) {
      border-left: 1px solid ${color('cta')};
    }
  }
`;

//
//
// Shared elements between StackedSingle and StackedStats
//
export const StyledVerticalLineSeparator = styled(VerticalLineSeparator)`
  @media screen and (${query.atLeast('desktop')}) {
    display: none;
  }
`;

export const StackedItem = styled.div`
  text-align: center;
  width: 100%;
  flex: 0 0 auto;
  margin: 0 auto;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  @media screen and (${query.atLeast('desktop')}) {
    padding: ${space('x10')} ${space('marginTablet')};
    width: 50%;
    flex: 0 0 auto;
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 400px;
  margin: 0 auto;
  align-items: center;
`;

// Text styles
export const Eyebrow = styled.h3`
  ${font('eyebrow-sm')};
  color: ${color('cta')};
  text-transform: uppercase;
  padding-bottom: ${space('md')};

  @media screen and (${query.atLeast('desktop')}) {
    ${font('eyebrow-md')};
    padding-bottom: ${space('xl')};
  }
`;

export const Header = styled.h2`
  ${font('headline-xxs')};
  padding-bottom: ${space('lg')};

  @media screen and (${query.atLeast('tablet')}) {
    ${font('headline-sm')};
    padding-bottom: ${space('x6')};
  }
`;

export const Text = styled.div`
  p {
    color: ${color('fg')};
    ${font('body-sm-light')};
    padding-bottom: ${space('x5')};
    margin-bottom: 0;

    @media screen and (${query.atLeast('desktop')}) {
      ${font('body-md-light')};
      padding-bottom: ${space('x7')};
    }
  }
`;
